export class ItemRequestJsEnv {
  // 画面controller側から渡されるパラメータ
  itemMakerName: string;
  itemName: string;
  makerModel: string;
  standardCode: string;
  comment: string;
  llCategoryCode: string;
  lCategoryCode: string;
  mCategoryCode: string;
  sCategoryCode: string;
  searchKeyWord: string;

  isFirstView: boolean = true;
  isSendSuccess: boolean = false;
  isSendFailed: boolean = false;

  constructor(
    itemMakerName: string,
    itemName: string,
    makerModel: string,
    standardCode: string,
    comment: string,
    llCategoryCode: string,
    lCategoryCode: string,
    mCategoryCode: string,
    sCategoryCode: string,
    searchKeyWord: string
  ) {
      this.itemMakerName = itemMakerName;
      this.itemName = itemName;
      this.makerModel = makerModel;
      this.standardCode = standardCode;
      this.comment = comment;
      this.llCategoryCode = llCategoryCode;
      this.lCategoryCode = lCategoryCode;
      this.mCategoryCode = mCategoryCode;
      this.sCategoryCode = sCategoryCode;
      this.searchKeyWord = searchKeyWord;
  }
}
